import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Container } from "semantic-ui-react";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class Support extends PureComponent {
  static propTypes = {
    copy: PropTypes.func.isRequired
  };

  render() {
    const { copy } = this.props;

    return (
      <Container>
        <h1>{copy("support.title")}</h1>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(Support);
